import { User } from "@aob/types";
import { createContext, useContext, useEffect, useState } from "react";
import { fetchJson } from "../api/utils";
import { removeAuthToken } from "../utils/storageService";

type UserContextType = {
  user: User | null;
  setUser: (user: User | null) => void;
};

export const UserContext = createContext<UserContextType>({
  user: null,
  setUser: () => {},
});

export const UserProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    fetchJson("/users/me")
      .then((data) => setUser(data.user))
      .catch((error) => {
        setUser(null);
        if (error.status === 401) {
          removeAuthToken();
        }
      });
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useUser = () => useContext(UserContext);
